import { EmbalagemService } from './../services/embalagem.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Filtro } from '../models/filtro';
import { Embalagem } from '../models/embalagem';
import { UtilitarioService } from '../services/utilitario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginatorService } from '../services/paginator.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';

@Component({
  selector: 'app-embalagem',
  templateUrl: './embalagem.component.html',
  styleUrls: ['./embalagem.component.scss']
})
export class EmbalagemComponent implements OnInit {
  embalagens: Embalagem[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  status = [{ id: -1, nome: 'Todos'}, { id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  statusSelecionado = 1;
  tipoEmbalagem = [{ id: -1, nome: 'Todos'}, { id: 0, nome: 'Pallet' }, { id: 1, nome: 'Caixa' }, { id: 2, nome: 'Cilindro' }];
  tipoEmbalagemSelecionado = -1;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private embalagemService: EmbalagemService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private paginatorService: PaginatorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarEmbalagens();
  }

  novaEmbalagem() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarEmbalagem(embalagem: Embalagem) {
    this.router.navigate(['editar', embalagem.id], { relativeTo: this.route });
  }

  buscarEmbalagens() {
    this.carregandoService.mostra('buscaEmbalagens');
    this.carregando = true;

    const tipoEmb = this.tipoEmbalagemSelecionado === -1 ? null : this.tipoEmbalagemSelecionado;

    this.embalagemService.consultarEmbalagensComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.statusSelecionado, tipoEmb).subscribe((data: any) => {
        this.embalagens = data.itens;
        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(data.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = data.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaEmbalagens');

      }, (erro) => {
        this.carregandoService.esconde('buscaEmbalagens');
        this.notificacaoService.erro(erro);
      });
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarEmbalagens();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.embalagens = this.embalagens.sort((a, b) => {
        const isAsc = !this.ordenarDesc;

        switch (this.campoOrdenacao) {
          case 'descricao': return this.compare(a.descricao, b.descricao, isAsc);
          default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  filtra() {
    this.buscarEmbalagens();
    this.paginator.firstPage();
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  softDeleteEmbalagem(embalagem: Embalagem) {
    this.carregandoService.mostra('softDeleteEmb');

    this.embalagemService.softDeleteEmbalagem(embalagem.id).subscribe(data => {
      this.notificacaoService.sucesso("Embalagem excluída com sucesso!");
      this.carregandoService.esconde('softDeleteEmb');
      this.filtra();
    }, (erro) => {
      this.carregandoService.esconde('softDeleteEmb');
      this.notificacaoService.erro("Não foi possível excluir a embalagem.");
    })
  }
}
